import React, { useEffect, useState } from 'react';
import { Alert, IconButton, Paper, Tooltip } from '@mui/material';
import '../../../../resources/styling/App.scss';
import TagRow from './TagRow';
import InsightsLoader from '../../InsightsLoader';
import { Stack, textAlign } from '@mui/system';
import AddEditTag from './AddEditTag';
import { colors } from '../../../../resources/theme/colors';
import { Add } from '@mui/icons-material';
import { surveyTagService } from '../../../../services/api/insights/surveyTagService';

const { mandy, pictonBlue } = colors;

export default function TagList({ selectedTag, setSelectedTag }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddTag, setShowAddTag] = useState(false);

  const handleEdit = (newTag) => {
    setTags([...tags.map((tag) => (tag.id === newTag.id ? newTag : tag))]);
    setSelectedTag([...newTag]);
  };

  const handleDelete = (tag) => {
    const newTags = tags.filter((t) => t.id !== tag.id);
    setTags([...newTags]);
    setSelectedTag(null);
  };

  useEffect(() => {
    setLoading(true);
    surveyTagService
      .getTags()
      .then((res) => {
        setTags(res.sort((x, y) => x.tag.localeCompare(y.tag)));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className='tag-list-container'>
      <div className='insight-heading'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <div>Template Tags</div>
          <div>
            <IconButton
              size='small'
              style={{ backgroundColor: mandy, color: 'white' }}
              onClick={() => setShowAddTag(true)}
            >
              <Tooltip title='Add New Tag' placement='top' arrow>
                <Add sx={{ fontSize: '20px' }}></Add>
              </Tooltip>
            </IconButton>
            <AddEditTag
              selectedTag={null}
              editTagDone={(doneOrCancel, t) => {
                setShowAddTag(false);
                if (doneOrCancel === 'done') {
                  let tt = [...tags, t];
                  tt.sort((x, y) => x.tag.localeCompare(y.tag));
                  setTags(tt);
                  setSelectedTag(t);
                }
              }}
              mode='add'
              openEdit={showAddTag}
            />
          </div>
        </Stack>
      </div>
      <div className='taglist'>
        {loading ? (
          <InsightsLoader />
        ) : tags?.length > 0 ? (
          tags.map((tag) => (
            <TagRow
              tag={tag}
              selectedTag={selectedTag}
              setSelectedTag={setSelectedTag}
              updateListAfterEdit={handleEdit}
              UpdateListAfterDelete={handleDelete}
            />
          ))
        ) : (
          <Alert severity='info'>No tags found</Alert>
        )}
      </div>
    </div>
  );
}
